<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M2 3h6v1.5H2z"/><path fill="currentColor" d="M2 7.25h9v1.5H2z"/><path fill="currentColor" d="M2 11.5h12V13H2z"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-sort',
});
</script>
